module.exports = __webpack_public_path__ + "img/toyota03.b63fe64e.png";